import { useCallback, useEffect, useState } from "react";
let token;
export function useOnfidoToken(getToken) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    useEffect(() => {
        if (token) {
            return;
        }
        setLoading(true);
        getToken()
            .then((data) => {
            token = data.token;
        })
            .catch((e) => {
            console.error("Error loading onfido token", e);
            if (e.status === 422) {
                setError("INVALID_LINK");
            }
            else {
                setError("UNKNOWN_ERROR");
            }
        })
            .finally(() => {
            setLoading(false);
        });
    }, [getToken]);
    const resetToken = useCallback(() => {
        token = "";
    }, []);
    const refetchToken = useCallback(() => {
        setLoading(true);
        token = "";
        getToken()
            .then((data) => {
            token = data.token;
        })
            .catch((e) => {
            console.error("Error loading onfido token", e);
            if (e.status === 422) {
                setError("INVALID_LINK");
            }
            else {
                setError("UNKNOWN_ERROR");
            }
        })
            .finally(() => {
            setLoading(false);
        });
    }, [getToken]);
    return { token, loading, error, resetToken, refetchToken };
}
